import axios from "axios";
import { Urls } from "../../../store/urls";

export const getPrivacyPolicyRepo = (data) => {
    return axios({
        method: "GET",
        url: Urls.GET_POST_STATIC_CONTENT_API,
        params: data,
    });
};

export const postPrivacyPolicyRepo = (data) => {
    return axios({
        method: "POST",
        url: Urls.GET_POST_STATIC_CONTENT_API,
        data: data,
    });
};

